module.exports = __webpack_public_path__ + "img/people-icon.2711486c.svg";